import { CreateOrdersModalContainer } from "src/app/containers";
import { OrderType } from "src/app/types/orders/order";

const LeadWorkerDashboard = () => {
    return (
        <div className="dashboardContainer">
            <div className="d-flex gap-2">
                <CreateOrdersModalContainer orderType={OrderType.FILLING} />
                <CreateOrdersModalContainer orderType={OrderType.RANK} />
            </div>
        </div>
    );
};

export default LeadWorkerDashboard;
